import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Flex, Heading, useDisclosure, Input, IconButton } from '@chakra-ui/react';
// import { NavLink } from 'react-router-dom';
import dayjs from 'dayjs';
// import { APP_ROUTES } from '_app/routes';
// import ConfirmationDialog from 'components/ConfirmationDialog';
import Table from 'components/Table';
// import { frontApi, API_ROUTES } from '_app/api';

import ExpandedComponent from './components/ExpandedComponent';
import { useStores } from 'hooks/useStores';
import EditModal from './components/EditModal';
import { DeleteIcon } from '@chakra-ui/icons';
import Modal from 'components/Modal';
import { CgUserList } from 'react-icons/cg'

// import useBulkMutation from '_common/hooks/useBulkMutation';
// import useMutation from '_common/hooks/useMutation';

const UsersPage = () => {
  const [editRow, setEditRow] = useState(null);
  const [detailsUser, setDetailsUser] = useState(null);

  const {
    usersStore: {
      data,
      fetchData,
      meta,
      isLoading,
      filters,
      errors,
      setFilters,
      removeFilter,
      clearAllFilters,
    },
  } = useStores();

  useEffect(() => {
    fetchData();
  }, []);


  const columns = React.useMemo(
    () => [
      {
        Header: 'Username',
        accessor: 'userName',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: 'Created',
        accessor: row => dayjs(row.createdAt).format('DD.MM.YYYY'),
      },
      {
        Header: 'Activated',
        accessor: row => row.activated.toString(),
      },
      {
        Header: 'Banned',
        accessor: row => row.banned.toString(),
      },
      {
        Header: 'Details',
        id: 'details',
        accessor: 'userName',
        Cell: ({ value }) => <IconButton variant="ghost" icon={<CgUserList />} onClick={() => setDetailsUser(value)} />
      },
    ],
    []
  );

  const rowActions = [
    {
      label: 'Edit',
      onClick: ({ original }) => {
        setEditRow(original);
      },
    },
  ];

  const onSubmit = (e) => {
    e.preventDefault();

    fetchData();
  }

  return (
    <>
      <Flex justifyContent="space-between" mb={8}>
        <Heading>Users</Heading>
      </Flex>
      <Flex justifyContent="flex-end" my={2} sx={{
        gap: 8
      }}>
        <form onSubmit={onSubmit}>
          <Input placeholder="Search by name" value={filters.userName || ''} onChange={e => setFilters('userName', e.target.value)} />
        </form>
        <form onSubmit={onSubmit}>
          <Input placeholder="Search by email" value={filters.email || ''} onChange={e => setFilters('email', e.target.value)} />
        </form>
        <IconButton icon={<DeleteIcon />} onClick={clearAllFilters} />
      </Flex>
      <Table {...{
        columns,
        data,
        fetchData,
        rowActions,
        isLoading,
        expandableRows: true,
        pageCount: meta.totalPages,
      }} />
      <EditModal {...{ key: data.id, data: editRow, onClose: () => setEditRow(null) }} />
      <Modal isOpen={!!detailsUser} onClose={() => setDetailsUser(null)}>
        <ExpandedComponent userName={detailsUser} />
      </Modal>
    </>
  );
};

export default observer(UsersPage);
